// Sürücü Puantajı — elle puantaj kaydı ekleme modalı.

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Modal from "shared/components/UIElements/Modal";
import Button from "shared/components/FormElements/Button";

import { KIND_ORDER, KIND_META, addDays, todayYMD } from "../utils";

const emptyForm = (defaultDate) => ({
  date: defaultDate || addDays(todayYMD(), -1),
  driverId: "",
  serviceName: "",
  kind: "STANDARD_PERSONEL",
  km: "",
  minutes: "",
  startTime: "",
  endTime: "",
});

const WorklogAddModal = ({ show, onClose, onAdd, driverOptions = [], maxDate, defaultDate }) => {
  const { t } = useTranslation();
  const max = maxDate || addDays(todayYMD(), -1);
  const [form, setForm] = useState(() => emptyForm(defaultDate || max));
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show) {
      const initialDate = defaultDate && defaultDate <= max ? defaultDate : max;
      setForm(emptyForm(initialDate));
      setError(null);
      setSubmitting(false);
    }
  }, [show, defaultDate, max]);

  const set = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const handleSubmit = async () => {
    if (!form.date || !form.driverId) {
      setError(t("driverPerformance.worklog.addRequired"));
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await onAdd({
        date: form.date,
        driverId: form.driverId,
        serviceName: form.serviceName || undefined,
        kind: form.kind,
        km: form.km ? Number(form.km) : 0,
        minutes: form.minutes ? Number(form.minutes) : 0,
        startTime: form.startTime || null,
        endTime: form.endTime || null,
      });
    } catch (err) {
      setError(err?.message || t("driverPerformance.worklog.saveFailed"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      onCancel={onClose}
      onClose={onClose}
      header={t("driverPerformance.worklog.addRow")}
      footer={
        <>
          <Button type="button" inverse onClick={onClose}>
            {t("driverPerformance.worklog.cancel")}
          </Button>
          <Button type="button" disabled={submitting} onClick={handleSubmit}>
            {t("driverPerformance.worklog.add")}
          </Button>
        </>
      }
    >
      <div className="wl-add-form">
        <label>
          {t("driverPerformance.worklog.date")}
          <input
            type="date"
            value={form.date}
            max={max}
            onChange={(e) => {
              const v = e.target.value;
              set("date", v && v > max ? max : v);
            }}
          />
        </label>
        <label>
          {t("driverPerformance.table.driver")}
          <select value={form.driverId} onChange={(e) => set("driverId", e.target.value)}>
            <option value="">{t("driverPerformance.worklog.selectDriver")}</option>
            {driverOptions.map((d) => (
              <option key={d.value} value={d.value}>
                {d.label}
              </option>
            ))}
          </select>
        </label>
        <label>
          {t("driverPerformance.worklog.service")}
          <input type="text" value={form.serviceName} onChange={(e) => set("serviceName", e.target.value)} />
        </label>
        <label>
          {t("driverPerformance.worklog.kind")}
          <select value={form.kind} onChange={(e) => set("kind", e.target.value)}>
            {KIND_ORDER.map((k) => (
              <option key={k} value={k}>
                {t(KIND_META[k].labelKey)}
              </option>
            ))}
          </select>
        </label>
        <div className="wl-add-form__row">
          <label>
            {t("driverPerformance.worklog.km")}
            <input type="number" min="0" step="0.1" value={form.km} onChange={(e) => set("km", e.target.value)} />
          </label>
          <label>
            {t("driverPerformance.worklog.minutes")}
            <input type="number" min="0" step="1" value={form.minutes} onChange={(e) => set("minutes", e.target.value)} />
          </label>
        </div>
        <div className="wl-add-form__row">
          <label>
            {t("driverPerformance.worklog.startTime")}
            <input type="time" value={form.startTime} onChange={(e) => set("startTime", e.target.value)} />
          </label>
          <label>
            {t("driverPerformance.worklog.endTime")}
            <input type="time" value={form.endTime} onChange={(e) => set("endTime", e.target.value)} />
          </label>
        </div>
        {error && <div className="wl-add-form__error">{error}</div>}
      </div>
    </Modal>
  );
};

export default WorklogAddModal;
